import SeoLandingLayout from "../../components/SeoLandingLayout";

export default function GoldJewelleryMeerut() {
  return (
    <SeoLandingLayout
      testId="gold-meerut-page"
      path="/gold-jewellery-meerut"
      seoTitle="Gold Jewellery in Meerut | 22K, 18K & Gold Coins | Ramesh Kapoor & Sons"
      seoDescription="Gold jewellery in Meerut — 22K and 18K chains, necklaces, bangles, rings, earrings, mangalsutras and 24K coins, with transparent rate-based pricing at Ramesh Kapoor & Sons Jewellers."
      crumbLabel="Gold Jewellery Meerut"
      eyebrow="Gold"
      h1={<>Gold Jewellery in <span className="italic text-[#C5A059]">Meerut</span></>}
      intro={[
        "Gold is where most jewellery journeys in Meerut begin — a first chain, a wedding set, a coin bought on an auspicious day. At Ramesh Kapoor & Sons Jewellers Pvt. Ltd., gold jewellery is the largest part of what we manufacture, wholesale and retail.",
        "This page explains our gold range and, just as importantly, how gold is priced — because an informed buyer is the customer we most enjoy serving.",
      ]}
      hero={{ src: "/images/hero-jewellery.jpg", alt: "Handcrafted 22K gold necklace with intricate Indian workmanship — gold jewellery at Ramesh Kapoor & Sons, Meerut" }}
      sections={[
        {
          id: "the-gold-range",
          eyebrow: "The Range",
          title: "Chains to Mangalsutras — the Gold Range",
          paragraphs: [
            "Our gold jewellery spans chains, necklaces, bangles, bracelets, rings, earrings, pendants and mangalsutras, in 22K (916) and 18K (750), alongside 24K gold coins. The range runs from light daily-wear pieces to full bridal sets, in both traditional Meerut taste and contemporary styles.",
            "For jewellers, the same range is available through our wholesale desk with product codes and weight ranges; for families, it is presented at our Abu Plaza retail showroom.",
          ],
        },
        {
          id: "pricing",
          eyebrow: "Transparency",
          title: "Purity and Pricing, Explained",
          paragraphs: [
            "The price of a gold piece is never a single number — it is the day's metal rate, the net weight, the purity, the making charges and applicable taxes, all disclosed separately. We publish the day's 24K, 22K and 18K rates openly on our live gold rate page, and final pricing is confirmed at the counter with every component shown.",
            "When comparing gold jewellery shops in Meerut, ask four questions of any piece: What is today's metal rate? What is the net weight? What purity is stamped? What are the making charges? We answer all four before any purchase is finalised.",
          ],
        },
        {
          id: "by-occasion",
          eyebrow: "Choosing",
          title: "Choosing Gold by Occasion",
          paragraphs: [
            "Daily wear asks for durability and comfortable weights; gifting asks for meaning within a budget; festivals and auspicious days often call for gold coins. Weddings deserve their own conversation — see our bridal jewellery page for that.",
            "Tell our team the occasion, budget and preferred weight range when you book an appointment, and a considered selection will be ready when you arrive.",
          ],
        },
      ]}
      faqs={[
        { q: "What purity of gold jewellery is available?", a: "Our gold jewellery is available in 22K (916) and 18K (750), with 24K gold in coin form. Purity is stamped and explained for every piece." },
        { q: "How is the price of a gold piece calculated?", a: "From the day's metal rate, the net weight, the purity, the making charges and applicable taxes — each component disclosed separately at the counter. The day's rates are published on our gold rate page." },
        { q: "Do you sell gold coins in Meerut?", a: "Yes, 24K gold coins are part of our range, alongside silver coins — popular for festivals, gifting and auspicious occasions." },
        { q: "Where can I check today's gold rate in Meerut?", a: "On our live gold rate page, which shows 24K, 22K and 18K gold and silver rates per gram and per 10 grams, with the time of the last update." },
        { q: "Can I shop for gold jewellery within a fixed budget?", a: "Yes. Share your budget, occasion and preferred weight range when booking a showroom appointment and our team will prepare suitable options in advance." },
      ]}
      cta={{
        title: <>Check the rate. <span className="italic text-[#C5A059]">Then choose the piece.</span></>,
        buttons: [
          { to: "/jewellery/rates", label: "Today's Gold Rate", primary: true },
          { to: "/jewellery/category/gold-jewellery", label: "Browse Gold Jewellery" },
          { to: "/jewellery/appointment", label: "Book an Appointment" },
        ],
      }}
      siblings={[
        { to: "/diamond-jewellery-meerut", label: "Diamond jewellery in Meerut" },
        { to: "/bridal-jewellery-meerut", label: "Bridal jewellery in Meerut" },
        { to: "/jewellery-meerut", label: "Jewellery in Meerut — overview" },
      ]}
    />
  );
}
